<template>
  <div class="dialog-wrapper" v-if="show">
    <div class="dialog-content" :style="{ 'width': width }">
      <img class="dialog-close" @click="closeDialog" src="@/profile/assets/icons/dialog-close.svg" alt="">
      <img v-if="icon === 'success'" class="dialog-icon" src="@/profile/assets/icons/dialog-success.svg" alt="">
      <img v-else-if="icon === 'warning'" class="dialog-icon" src="@/profile/assets/icons/dialog-warning.svg" alt="">
      <div class="dialog-title" v-html="title"></div>
      <div class="dialog-text" v-html="text"></div>
      <div class="dialog-btns">
        <button class="dialog-btn" @click="action(buttons[0].action)" >{{ buttons[0].text }}</button>
        <button class="dialog-btn primary" @click="action(buttons[1].action)" >{{ buttons[1].text }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "makc-dialog2",
  props: {
    title: {
      type: String
    },
    text: {
      type: String
    },
    buttons: {
      type: Array
    },
    show: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String
    },
    width: {
      type: String,
      default: "607px"
    },
  },
  methods: {
    action(method) {
      if (method === "hideDialog") {
        this.$emit("cancel");
      }
      if (method === "terminate") {
        this.$emit("terminate");
      }
    },
    closeDialog() {
      this.$emit("update:show", false);
    }
  }
};
</script>

<style scoped>

</style>